/**
 * Navigation Types for Macro Orientation Layer
 * Defines intent-based navigation state and routes
 */

export type MacroIntent =
  | 'design-portfolio'
  | 'connect-broker'
  | 'analyze-portfolio'
  | 'improve-performance'
  | 'improve-taxes'
  | 'monitor';

export type DiscoverMode = 'design' | 'replacement' | 'exploration' | null;
export type DashboardMode = 'analysis' | 'monitoring' | null;
export type PortfolioMode = 'design' | 'analysis' | 'actual' | null;
export type TradingFocus = 'tlh' | 'rebalance' | 'general' | null;

export interface NavigationState {
  discoverMode?: DiscoverMode;
  dashboardMode?: DashboardMode;
  portfolioMode?: PortfolioMode;
  tradingFocus?: TradingFocus;
}

export interface IntentCard {
  id: MacroIntent;
  title: string;
  description: string;
  icon: string; // Font Awesome icon class
  targetRoute: string;
  targetState: NavigationState;
}

export const INTENT_CARDS: IntentCard[] = [
  {
    id: 'design-portfolio',
    title: 'Design My Portfolio',
    description: 'Build your ideal target portfolio from strategies and securities',
    icon: 'fa-solid fa-compass-drafting',
    targetRoute: '/search',
    targetState: { discoverMode: 'design', portfolioMode: 'design' },
  },
  {
    id: 'connect-broker',
    title: 'Connect My Broker',
    description: 'Link your brokerage accounts to sync positions and execute trades',
    icon: 'fa-solid fa-link',
    targetRoute: '/broker-connect',
    targetState: {},
  },
  {
    id: 'analyze-portfolio',
    title: 'Analyze My Portfolio',
    description: 'See how your actual holdings compare to your target allocation',
    icon: 'fa-solid fa-chart-bar',
    targetRoute: '/portfolio',
    targetState: { dashboardMode: 'analysis', portfolioMode: 'analysis' },
  },
  {
    id: 'improve-performance',
    title: 'Improve Performance',
    description: 'Identify opportunities to optimize returns and reduce risk',
    icon: 'fa-solid fa-rocket',
    targetRoute: '/dashboard',
    targetState: { dashboardMode: 'analysis' },
  },
  {
    id: 'improve-taxes',
    title: 'Reduce My Taxes',
    description: 'Find tax-loss harvesting opportunities to minimize tax burden',
    icon: 'fa-solid fa-leaf',
    targetRoute: '/tlh',
    targetState: { tradingFocus: 'tlh' },
  },
  {
    id: 'monitor',
    title: 'Monitor My Portfolio',
    description: 'Track portfolio performance and stay updated on market changes',
    icon: 'fa-solid fa-eye',
    targetRoute: '/dashboard',
    targetState: { dashboardMode: 'monitoring' },
  },
];
